import React from "react";
import * as Yup from "yup";
import yupSchema from "../../../constants/schema";
import { useErrorHandler } from "../../../hooks";
import DialogFormBuilder from "../../../components/dialog-form-builder";
import redirectService from "../../../services/redirect.service";

const initialValues = {
  url: "",
  redirect: "",
};
const schema = Yup.object().shape({
    url: yupSchema.name,
    redirect: yupSchema.redirect,
});
const form = [
  {
    _type: "textField",
    name: "url",
    label: "آدرس",
    autoFocus: true,
  },
  {
    _type: "textField",
    name: "redirect",
    label: "مقصد",
  },
];

export default function FormModalContent({ close, data, extra }) {
  const errorHandler = useErrorHandler();

  const handleSubmit = async (model, { setSubmitting }) => {
    let op;
    op = await redirectService.createRedirect(model);
    const { error } = op;
    setSubmitting(false);
    if (error) return errorHandler(error);

    close(true);
  };

  return (
    <DialogFormBuilder
      {...{
        close,
        name: "Redirect",
        data,
        schema,
        initialValues: {
            ...initialValues,
            ...data
        },
        handleSubmit,
        form,
      }}
    />
  );
}
